const diacritics: Record<string, string> = {
  a: "ÀÁÂÃÄÅàáâãäåĀāąĄ",
  c: "ÇçćĆčČ",
  d: "đĐďĎ",
  e: "ÈÉÊËèéêëěĚĒēęĘ",
  i: "ÌÍÎÏìíîïĪī",
  l: "łŁ",
  n: "ÑñňŇńŃ",
  o: "ÒÓÔÕÕÖØòóôõöøŌō",
  r: "řŘ",
  s: "ŠšśŚ",
  t: "ťŤ",
  u: "ÙÚÛÜùúûüůŮŪū",
  y: "ŸÿýÝ",
  z: "ŽžżŻźŹ",
};

function replaceDiacritics(text: string) {
  for (const toLetter in diacritics) {
    if (Object.prototype.hasOwnProperty.call(diacritics, toLetter)) {
      for (let i = 0, ii = diacritics[toLetter].length, fromLetter, toCaseLetter; i < ii; i++) {
        fromLetter = diacritics[toLetter][i];
        if (text.indexOf(fromLetter) < 0) continue;
        toCaseLetter = fromLetter === fromLetter.toUpperCase() ? toLetter.toUpperCase() : toLetter;
        text = text.replace(new RegExp(fromLetter, "g"), toCaseLetter);
      }
    }
  }
  return text;
}

const urlOfferParser = (value: string | number) => {
  let str = String(value)
    .replace(/[\p{P}\p{S}]/gu, "")
    .replace(/ {2,}/g, " ")
    .replace(/\s/g, "-");
  str = replaceDiacritics(str);
  const str1 = str.charAt(str.length - 1);
  if (str1 === "-" && str1 === str.charAt(str.length - 2)) {
    str = str.substring(0, str.length - 1);
  }

  return str;
};

export const offerLink = (name: string, offerId: number) =>
  `/offer/${[urlOfferParser(name), offerId].join("-")}`;
